// @ts-nocheck
import { lazy } from 'react';
export const AddTerminalScreenAsync = lazy(
  () => import('./AddTerminalScreen.tsx'),
);
